import React from "react";

const TableHeader = ({ heading }) => {
  return (
    <th
      scope="col"
      className="px-4 py-3 whitespace-nowrap text-left"
      style={{
        fontSize: "0.7rem",
        fontWeight: 700,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        color: "var(--color-text-muted)",
        background: "#F8FAFC",
        borderBottom: "1px solid var(--color-border)",
      }}
    >
      {heading}
    </th>
  );
};

export default TableHeader;
